import { Localizations } from '@eig-builder/module-localization'

Localizations.append({
  modules: {
    crm: {
      components: {
        account: {
          refund: {
            select: {
              label: 'Refund type',
              none: 'None',
              refund: 'Refund',
              credits: 'Credits'
            },
            description: 'Should the customer receive a refund?',
            extendedDescription: 'Should the customer receive a refund or credits?',
            total: 'Total',
            tableRow: {
              planName: 'Plan name',
              renewDate: 'Renewal date',
              amount: 'Amount'
            },
            initialDomainRegistrationFee: 'Domain Reg. Fee',
            loading: 'Checking for refund possibilities...'
          }
        }
      }
    }
  }
})
